// Shared by world.ts and levels.ts
export const K = 'jelly';
export const DEG = Math.PI / 180;
